// import * as Device from '../../../expo-device'

function isSlowDeviceUtil () {
  return false
  // const { deviceYearClass } = Device
  // return deviceYearClass < 2020
}

export {
  isSlowDeviceUtil
}
